(function ($, Drupal) {
  Drupal.behaviors.slickInit = {
    attach: function (context, settings) {

      once('pslider--wrapper', '.p-slider .slider-wrapper', context).forEach((e) => {
        $(e).slick({
          slide: '.paragraph'
        });
      });

      once('js-gallery', '.js-gallery', context).forEach((e) => {
        var slideCount = $(e).children().length;

        $(e).slick({
          infinite: slideCount > 2,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          initialSlide: Math.floor( slideCount/ 2),
          variableWidth: true,

          responsive: [
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]

        });
      });

    }
  }
})(jQuery, Drupal);
